export function paginationPages(currentPage: number, totalPages: number) {
  if (totalPages < 8) {
    return Array.from(Array(totalPages), (_, index) => index + 1);
  }
  let pages = [
    1,
    2,
    currentPage - 1,
    currentPage - 0, // forcing integer type
    currentPage - -1, // forcing integer type
    totalPages - 1,
    totalPages - 0, // forcing integer type
  ];
  pages = pages.filter((page) => page > 0 && page <= totalPages);
  pages = pages.filter((value, index, array) => array.indexOf(value) === index);
  pages.sort((a, b) => {
    return a - b;
  });
  let prevPage = 1;
  let returnPages = [] as number[];
  pages.forEach((page) => {
    if (page === prevPage + 2) {
      returnPages.push(prevPage + 1);
    }
    prevPage = page;
    returnPages.push(page);
  });
  return returnPages;
}
